import { Component, OnInit } from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {AuthService} from '../../../../../core/service/auth.service';
import {StatsService} from '../../services/stats.service';
import {DatesParserService} from '../../../../../core/service/dates_parser.service';
import {Stats} from '../../model/stats';
import {ModalService} from 'ngx-dynamic-modal';
import {StatsChartModalComponent} from '../modal/stats-chart-modal/stats-chart-modal.component';
import {OrderModule, OrderPipe} from 'ngx-order-pipe';

import { Angular2Csv } from 'angular2-csv/Angular2-csv';
import * as _ from 'underscore';
import * as moment from 'moment';
import {isBoolean} from 'util';
import {MessagingService} from '../../../../../core/service/messaging.service';
import {VnaPortalAppSelected} from '../../../../../core/data/messaging/VnaPortalAppSelected';
import {LocalStorageService} from 'ngx-webstorage';
import {OrderStatsByPipe} from '../../pipe/order-stats-by.pipe';
import {ActionsDateListComponent} from '../../../../../shared/components/actions-date-list/actions-date-list.component';
import {VnaPortalSelected} from '../../../../../core/data/messaging/VnaPortalSelected';
import {element} from 'protractor';

@Component({
  selector: 'app-stats',
  templateUrl: './stats.component.html',
  styleUrls: ['./stats.component.scss']
})
export class StatsComponent implements OnInit {

    formSearch: FormGroup;
    errors: Object;
    submitted: boolean = false;
    stats: Stats;

    enabled: boolean = false;
    fromHr:any;
    toHr:any;

    reverseAvg:boolean=true;
    orderAvg:any=null;
    reverseCounts:boolean=true;
    orderCounts:any=null;

    headers:any;

    constructor(private orderPipe: OrderPipe, private auth: AuthService, private statsHandler: StatsService, private datesParser: DatesParserService, private modalHandler: ModalService,
                private messaging: MessagingService, private localStorage: LocalStorageService) {
        let from= new Date();
        from.setHours(0,0,0,0);
        this.fromHr=from;
        let to= new Date();
        to.setHours(23,59,59,0);
        this.toHr=to;
        this.errors = {};
        this.stats = new Stats();
        this.formSearch = new FormGroup(
            {
                'start_date' : new FormControl('', Validators.required),
                'end_date' : new FormControl('', Validators.required),
                'provider' : new FormControl('', Validators.required),
                'service_provider' : new FormControl(),
                'config_name' : new FormControl(),
                'element_type' : new FormControl(),
                'pk_vna_camp' : new FormControl(),
                'pk_vna_action_camp' : new FormControl(),
                'lang' : new FormControl(),
                'type_stats' : new FormControl(),
                'group_type' : new FormControl(),
                'exclusion' : new FormControl(''),
            }
        );

    }

    findStats() {
        this.errors = {};
        if(!this.formSearch.valid){
            this.submitted = true;
            return;
        }

        this.getStats();
    }

    statsToCsv(type: string = 'avg'): void {
        let headers = this.stats.headers.map( (o) => {
            return o['label'];
        });

        let rows = [];
        let rowsToParse = (type == 'avg') ? this.stats.rowsAvg : this.stats.rowsCount;
        rowsToParse.forEach( (data: Array<Object>) => {
            let row: Array<string> = [];
            data.forEach( (o) => {
                row.push(o['value']);
            });

            rows.push(row);
        });
        new Angular2Csv(rows, 'stats_report_' + moment().unix(), {
            'showLabels' : true,
            'headers' : headers
        });
    }

    showChart(): void {
        this.modalHandler.addDynamicComponent(StatsChartModalComponent, this.stats.pieData );
    }

    ngOnInit() {

        let params: any = this.localStorage.retrieve('stats.dashboard.portal_params');
        if(params && params.length > 0){
            params = JSON.parse(params);

            this.formSearch.controls['provider'].setValue('beeztel'); // Todo: Ojo, tendrá que llegar por parametro. Esta así porque ahora solo tenemos un servicio en uso
            this.formSearch.controls['type_stats'].setValue('response');
            this.formSearch.controls['group_type'].setValue('hourly');

            for(let key in params){
                if(key == 'portal'){
                    if(params[key] != this.auth.getPortalSelected().portal){
                        this.messaging.sendMessage(new VnaPortalAppSelected(params[key]));
                    }

                }
                else {
                    const value: any = (key.match(/date/g)) ? moment(params[key]) : params[key];
                    this.formSearch.controls[key].setValue(value);
                }
            }

            this.getStats();
        }

        this.localStorage.clear('stats.dashboard.portal_params');
    }

    showActions(row: Object): void {
        this.modalHandler.addDynamicComponent(ActionsDateListComponent,
            {
                'current_date' : row[0]['value'],
                'portal_pk' : this.auth.getPkPortal(),
                'service' : this.formSearch.value.provider
            }
        );
    }

    protected getStats(): void {
        this.enabled = true;
        var formData = this.datesParser.cleanDates(this.formSearch.value, ['start_date', 'end_date'], false);
        var query = Object.assign({}, formData, {'portal' : this.auth.getPortalSelected().getPortal()});

        if(_.isArray(query['pk_vna_camp'])){
            query['pk_vna_camp'] = _.reduce(query['pk_vna_camp'], (memo, element) => {
                return (memo.length == 0) ? element['pk'] : memo + ',' + element['pk'];
            }, "")
        }

        if(_.isArray(query['pk_vna_action_camp'])){
            query['pk_vna_action_camp'] = _.reduce(query['pk_vna_action_camp'], (memo, element) => {
                return (memo.length == 0) ? element['pk'] : memo + ',' + element['pk'];
            }, "")
        }

        this.statsHandler.getStats(query).subscribe(
            (result) => {
                if(result.hasOwnProperty('errors')){
                    this.errors = result.errors;
                }
                else{
                    this.stats.setRowsCount(result);
                    this.stats.setHeaders(result);
                    this.stats.setRowsAvg(result);
                    this.stats.setPieData(result);
                    this.stats.setType('pie');
                    this.headers = this.stats.getHeaders(false);
                }

                this.enabled = false;

            }
        )
    }

    prsFloat(a,b){
        return parseFloat(a) > parseFloat(b)?1:-1

    }
}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/analytics/stats/components/stats/stats.component.ts